@if (!isEmbedded) {
  <div
    class="update-list-header"
    [class.expanded]="isSearchVisible"
  >
    <app-search-box
      [isSearchVisible]="isSearchVisible"
      [collapsible]="true"
      (searchValueChange)="onSearchValueChange($event)"
      (searchStarted)="onSearchStarted()"
      (searchClosed)="onSearchClosed()"
    ></app-search-box>

    <app-filter-button
      [options]="categories"
      [selectedValue]="activeCategory"
      [showLabel]="false"
      (selectionChange)="onFilterSelection($event)"
    />
  </div>
}

@if (ready) {
  @for (update of updatesState; track update.id) {
    @if (!update.ratingMonitorPush || project()?.ratingMonitorDue) {
      <app-card
        (itemVisible)="onItemVisible($event)"
        [type]="update.ratingMonitorPush ? CardType.RATING : CardType.UPDATE"
        [dateAdded]="update.publicationDate"
        [update]="update"
        [project]="project() ?? update.project"
        [withHeader]="true"
        [withNavigation]="false"
        [withFollowers]="false"
        [language]="update.project?.language"
        [className]="'card--update'"
        [readOnlyInteractions]="!interactionsReady"
        [likedType]="updatesDeviceData?.[update.id]?.likedType"
      ></app-card>
    }
  }
  <ion-infinite-scroll
    [hidden]="updatesState?.length === totalUpdatesState"
    (ionInfinite)="loadUpdates($event)"
  >
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
} @else {
  <app-loader [loading]="true"></app-loader>
}

@if (ready && updatesState?.length === 0) {
  <app-state-notice
    iconPath="/assets/illustrations/no_new_updates.svg"
    [title]="'updates.empty.title' | translate"
    [desc]="'updates.empty.desc' | translate"
  />
}
